import { EmptyValue } from "@bcc/components/ui";
import { formatCurrency } from "@client-shared/utils";
import type { PurchaseOrderInvoice } from "@shared/types/payout";
import { CellContext } from "@tanstack/react-table";

export const InvoiceVatAmountCell = (props: CellContext<PurchaseOrderInvoice, unknown>) => {
  const { invoiceLines, currencyCode, invoiceStatus } = props.row.original;

  if (invoiceStatus === "Unposted") {
    return (
      <div className="text-sm leading-snug">
        <EmptyValue />
      </div>
    );
  }

  const hasVatData = invoiceLines.some((item) => item.vatAmount != null);
  if (!hasVatData) {
    return (
      <div className="text-sm leading-snug">
        <EmptyValue />
      </div>
    );
  }

  const totalVat = invoiceLines.reduce((sum, item) => sum + (item.vatAmount ?? 0), 0);
  return <div>{formatCurrency(totalVat, currencyCode || "USD")}</div>;
};
